module.exports = __webpack_public_path__ + "313505cf0a429fd89292b13e12ad7fec.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/company/sharing-center/shared-notes/shared-notes.html
// module id = 1885
// module chunks = 0